export default __webpack_public_path__ + "static/koona-logo-b125c5f411374254bb3b242a39798803.png";